module.exports = __webpack_public_path__ + "images/sgp/10x20/interior-car-storage.jpg";